import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ShippingOptionSettingsComponent = ({ selectLogisticsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Delivery"
                            name="Delivery"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingOptionSettings.Delivery',
                                    selectLogisticsSettings?.ShippingOptionSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingOptionSettings?.Delivery}
                        />
                        <InputContainer
                            label="SelfPickup"
                            name="SelfPickup"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingOptionSettings.SelfPickup',
                                    selectLogisticsSettings?.ShippingOptionSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingOptionSettings?.SelfPickup}
                        />

                        <InputContainer
                            label="Delivery And SelfPickup"
                            name="DeliveryAndSelfPickup"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingOptionSettings.DeliveryAndSelfPickup',
                                    selectLogisticsSettings?.ShippingOptionSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingOptionSettings?.DeliveryAndSelfPickup}
                        />
                    </div>
                }
                expandedPanel="ShippingOption Settings"
                headerTitle="ShippingOption Settings"
            />
        </>
    )
}
export default ShippingOptionSettingsComponent;
